import React from 'react'

const DayPickerRangeContext = React.createContext()

export default DayPickerRangeContext
